import { format } from "date-fns";

export function formatDate(
  value: string | number | Date | null | undefined,
  fallback = "N/A",
) {
  if (!value) {
    return fallback;
  }

  const parsed = value instanceof Date ? value : new Date(value);

  if (Number.isNaN(parsed.getTime())) {
    return fallback;
  }

  return format(parsed, "dd MMM yyyy");
}
